import React, { useState, useEffect, useRef } from 'react';

export function useOverflow(content: React.ReactNode) {
  const ref = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (ref.current) {
        const { scrollWidth, clientWidth } = ref.current;
        setIsOverflowing(scrollWidth > clientWidth);
      }
    };
    checkOverflow();
  }, [content]);
  return { ref, isOverflowing };
}
